module.exports = __webpack_public_path__ + "media/assets/services_manager/left-arrow-a92099aca49744535a392d0e36011a01bdab83c434650caefeda856a68a3b706.svg";